// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__yL3ID","title":"Header_title__3FrOi","side":"Header_side__PoEW4"};